function openLightbox(event) {
    const lightboxes = document.querySelectorAll('.lightbox__trigger')
    const currentVideo = document.getElementById("lightbox")
    const video = document.getElementById("lightbox-video");

    lightboxes.forEach(lightbox => {
        lightbox.addEventListener('click', e => {
            video.src = e.currentTarget.dataset.vidSrc
            currentVideo.style.display = "block"
        })
    })
}

function closeLightbox() {
    const lightbox = document.getElementById("lightbox")
    const video = document.getElementById("lightbox-video")
    // video.pause(); // Pause the video
    // video.contentWindow.stop()
    // video.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'stopVideo' }), '*')
    video.src = ''
    lightbox.style.display = "none"
}

window.addEventListener("click", function(event) {
    const lightbox = document.getElementById("lightbox");
    const video = document.getElementById("lightbox-video");

    // Check if the clicked element is outside the lightbox or is the close button
    if (event.target === lightbox || event.target.classList.contains("lightbox__close")) {
        video.src = ''
        lightbox.style.display = "none"
    }
});